import React from 'react';
import _ from 'lodash';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { useTranslation } from 'react-i18next';
import AddOnGeniusFaq from './GeniusR/AddOnGeniusFaq';
import AuthorProfile from '../common/AuthorProfile';
const { API } = require('../../config/' + process.env.REACT_APP_ENV);
const ContentfulFaqs = ({
  drugInfo,
  mailOrderPricings,
  selectedDisplayQuantity,
  heading = ''
}) => {
  const { t, i18n } = useTranslation();
  const displayAuthorProfile = (withDiscription = false) => (
    <AuthorProfile
      authorTitle={t('Medically reviewed by')}
      authorProfileLink={
        drugInfo.cmsData.medicalReviewer?.reviewerPageOnSingleCare
      }
      authorDes={drugInfo.cmsData.medicalReviewer?.title}
      authorName={drugInfo.cmsData.medicalReviewer?.name}
      authorQualifications={drugInfo.cmsData.medicalReviewer?.qualifications}
      authorImg={drugInfo.cmsData.medicalReviewer?.photo}
      description={
        withDiscription &&
        documentToReactComponents(
          JSON.parse(drugInfo.cmsData.medicalReviewer?.biography || null)
        )
      }
    />
  );
  return (
    <section className="drug-faqs">
      <div className="faq-list drug-faq-list">
        <h2 id="faqs-heading" className="faq-heading">
          {!_.isEmpty(heading)
            ? `${heading}`
            : _.isEqual(i18n.language, 'en')
            ? `${drugInfo.cmsData.name} ${t('FAQs')}`
            : `${t('FAQs')} ${drugInfo.cmsData.name}`}
        </h2>
        {drugInfo.cmsData &&
          drugInfo.cmsData.medicalReviewer &&
          !_.isEmpty(drugInfo.cmsData.medicalReviewer.name) && (
            <div className="userDataInfo">{displayAuthorProfile(false)}</div>
          )}
        {documentToReactComponents(drugInfo.cmsData.faqs)}
        {API.ALLOW_HOME_DELIVERY && !_.isEmpty(mailOrderPricings) && (
          <AddOnGeniusFaq
            mailOrderPricings={mailOrderPricings}
            selectedDisplayQuantity={selectedDisplayQuantity}
            mailOrderTemplate={drugInfo.cmsData.mailOrderTemplate}
          />
        )}
        {drugInfo.cmsData &&
          drugInfo.cmsData.medicalReviewer &&
          !_.isEmpty(drugInfo.cmsData.medicalReviewer.name) && (
            <div className="bottomUserDataInfo">
              <div className="authorLists">{displayAuthorProfile(true)}</div>
            </div>
          )}
      </div>
    </section>
  );
};
export default React.memo(ContentfulFaqs);
